import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findActionIn, findFirstAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { GET_PROJECT_ACTIONS } from './actionNames';
import { invalidateProjectLists } from './queries';
export function useEditDLProject() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    // Active get-action name — the detail cache key the edit response writes through to.
    const getName = (user && findFirstAction(user, GET_PROJECT_ACTIONS)?.name) || GET_PROJECT_ACTIONS[0];
    return useMutation({
        mutationFn: async ({ project, edits }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findActionIn(project.potentialAction, 'edit');
            if (!action)
                throw new Error('edit action unavailable for this project');
            if (!project.id)
                throw new Error('project.id missing');
            const body = { object: project.id };
            if (edits.name !== undefined)
                body.name = edits.name;
            if (edits.address !== undefined)
                body.address = edits.address;
            if (edits.description !== undefined)
                body.description = edits.description;
            if (edits.status !== undefined)
                body.status = edits.status;
            if (edits.agencyNotes !== undefined)
                body.agencyNotes = edits.agencyNotes;
            if (edits.agentNotes !== undefined)
                body.agentNotes = edits.agentNotes;
            const response = await invokeAction(action, user.token, { body });
            if (!response.ok)
                throw new Error(`editDLProject returned ${response.status}`);
            const json = (await response.json());
            const updated = json.object;
            if (!updated)
                throw new Error('editDLProject response missing object');
            return updated;
        },
        onSuccess: (updated) => {
            const uuid = updated.UUID;
            if (uuid && user?.email) {
                queryClient.setQueryData([getName, user.email, uuid], updated);
            }
            invalidateProjectLists(queryClient, user?.email);
        },
    });
}
